import React from 'react'
import styled from 'styled-components'
import { LKButton as LKBaseButton } from 'loankeeper-common/components'

import LKModal, { LKModalContainer } from '../shared/LKModal'
import { useTicker } from '../../hooks'
import { translateLKM } from './helpers'

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  .timeout-logo {
    margin: 0 20px;
    width: 150px;
  }
`

const Ticker = () => {
  const secondsLeft = useTicker(60)

  return <p>{`დარჩენილი დრო: ${secondsLeft}`}</p>
}

const STKExpiringWarning = ({ modalInstanceName, closeModal }) => (
  <LKModal
    icon="alert"
    name={modalInstanceName}
    heading={translateLKM('MSG_WARNING')}
    size="xs"
    footer={
      <LKModal.Footer>
        <LKBaseButton.Okay onClick={closeModal} />
      </LKModal.Footer>
    }
  >
    <Wrapper>
      <img className="timeout-logo" src="/static/img/test_logo.png" alt="logo" />
      <div>
        <p>სესიას ვადა გასდის, გსურთ დარჩეთ სისტემაში?</p>
        <Ticker />
      </div>
    </Wrapper>
  </LKModal>
)

export default LKModalContainer('STKExpiring')(STKExpiringWarning)
